import {
  Button,
  ButtonGroup,
  DropdownButton,
  Dropdown,
  Col,
  Row,
} from 'react-bootstrap'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import StudentCourseService from '../../service/studentCourseService'
import MajorCourseService from '../../service/majorCourseService'
import ExportReactCSV from '../Utils/ExportReactCSV'
import useToken from '../../App/useToken'
import { successNotify, errorNotify } from '../Utils/Toast'
import SearchStudentModal from '../SearchStudentModal/SearchStudentModal'
import StudentChangeTermModal from '../StudentChangeTermModal/StudentChangeTermModal'
import StudentCourseSortModal from '../StudentCourseSortModal/StudentCourseSortModal'
import ApproveStudentCourseModal from '../ApproveStudentCourseModal/ApproveStudentCourseModal'
import ClearStudentCourseModal from '../../components/ClearStudentCourseModal/ClearStudentCourseModal'
import StudentCourseTable from '../StudentCourseTable/StudentCourseTable'
import ReactTooltip from 'react-tooltip'
import { CSVLink } from 'react-csv'
import 'react-tabs/style/react-tabs.css'
import './StudentCourse.css'

export default function StudentCourse({
  courseId,
  studentCourses,
  setStudentCourses,
  fetchStudentCourseAt,
  isStudentCourseLoading,
  courseInfo,
  courseUpdateAvailable,
  fetchStudentCourseDisabled,
}) {
  const { getToken, isUnitAdminOrUnitSpcAdmin, getRole, isAdmin } = useToken()
  const token = getToken()
  const isUserUnitAdminOrUnitSpcAdmin = isUnitAdminOrUnitSpcAdmin()
  const isUserAdmin = isAdmin()
  const role = getRole()
  const { major_name, course_name } = useParams()
  const courseArray = course_name.split(' ')
  const isTestCourse = courseArray[0] == 'TEST'

  const [showClearStudentCourseModal, setShowClearStudentCourseModal] =
    useState(false)
  const [showApproveStudentCourseModal, setShowApprovStudentCourseModal] =
    useState(false)
  const [showStudentCourseSortModal, setShowStudentCourseSortModal] =
    useState(false)
  const [showAddStudentModal, setShowAddStudentModal] = useState(false)
  const [showStudentChangeTermModal, setShowStudentChangeTermModal] =
    useState(false)
  const [studentChangeData, setStudentChangeData] = useState()
  const [isFetchStudentCourseLoading, setIsFetchStudentCourseLoading] =
    useState(false)
  const [terms, setTerms] = useState([])
  const [isSpcApprove, setIsSpcApprove] = useState(false)
  const [activeTerm, setActiveTerm] = useState(0)
  const [eclFile, setEclFile] = useState()
  const [finalTermFile, setFinalTermFile] = useState()
  const [healthFile, setHealthFile] = useState()
  const [allFile, setAllFile] = useState()
  const [studentCourseExport, setStudentCourseExport] = useState([])
  const [fetchStudentsAt, setFetchStudentsAt] = useState()
  const [isStudentCourseApprove, setIsStudentCourseApprove] = useState(false)
  const [studentCourseApproveAt, setStudentCourseApproveAt] = useState()
  const [sortProfile, setSortProfile] = useState()
  const [sortProfileText, setSortProfileText] = useState('ไม่มีการจัดเรียง')
  const [isStudentAll, setIsStudentAll] = useState(true)
  const [majorCourse, setMajorCourse] = useState()

  const handleAddStudentModalShow = () => setShowAddStudentModal(true)
  const handleOnImportEcl = () => {
    document.getElementById('eclFile').click()
  }
  const handleOnImportHealth = () => {
    document.getElementById('healthFile').click()
  }
  const handleOnImportFinalTerm = () => {
    document.getElementById('finalTermFile').click()
  }
  const handleOnImportAllFile = () => {
    document.getElementById('allFile').click()
  }
  const handleOnExcelFileClick = () => {
    document.getElementsByClassName('excelFile')[0].click()
  }
  const handleOnGetEclInHRIS = async () => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.getEclInHRISByCourseId(
      courseId,
      token,
    )
    getStudentCourse()
  }
  const handleOnGetHealthInHRIS = async () => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.getHealthInHRISByCourseId(
      courseId,
      token,
    )
    getStudentCourse()
  }
  const handleOnExportEcl = () => {
    document.getElementById('requestEclFile').click()
  }
  function handleStudentChangeTermModalShow(data) {
    setShowStudentChangeTermModal(true)
    setStudentChangeData(data)
  }

  const handleSetStudentCourseExport = (csvDatas) => {
    const tempData = []
    csvDatas.map((csvData, index) =>
      tempData.push({ ...csvData, index: index + 1 }),
    )
    return tempData
  }

  const getStudentCourse = async (sort) => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.getStudentCourseByCourseName({
      course_name,
      token,
      sort,
    })
    setStudentCourseResponse(res)
  }

  const clearStudentCourseSort = async () => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.clearStudentCourseSortByCourseName({
      course_name,
      token,
    })
    getStudentCourse()
    successNotify('ล้างการจัดเรียงลำดับสำเร็จ')
  }

  const getStudentCourseOnlyPassQualified = async () => {
    if (isStudentAll) {
      const studentCourseService = new StudentCourseService()
      const res = await studentCourseService.getStudentCourseByCourseName({
        course_name,
        token,
        passQualified: true,
      })
      setStudentCourseResponse(res)
      setIsStudentAll(false)
    } else {
      getStudentCourse()
      setIsStudentAll(true)
    }
  }

  const setStudentCourseResponse = (res) => {
    if (res?.studentInTermcourse) {
      setStudentCourses(res.studentInTermcourse)
      setStudentCourseExport(
        handleSetStudentCourseExport(res.studentInTermcourse[0].data),
      )
      setIsSpcApprove(res.majorCourse.is_spc_approve)
      setMajorCourse(res.majorCourse)
      setTerms(res.terms)
      setFetchStudentsAt(res.fetchStudentsAt)
      setIsStudentCourseApprove(res.isStudentCourseApprove)
      setStudentCourseApproveAt(res.studentCourseApproveAt)
      setSortProfile(res.sortProfile)
    }
    return res
  }

  const handleOnArrangeTerm = async (role) => {
    const studentCourseService = new StudentCourseService()
    await studentCourseService
      .arrangeTerm(courseId, token, role)
      .then((res) => {
        successNotify('จัดเรียงสำเร็จ')
        getStudentCourse()
      })
      .catch((err) => {
        errorNotify(err.message)
      })
  }

  const fetchStudentCourse = async () => {
    setIsFetchStudentCourseLoading(true)
    const majorCourseService = new MajorCourseService()
    const res = await majorCourseService.fetchStudentCourse(
      major_name,
      course_name,
      token,
    )
    if (res?.type == 'error') errorNotify('เกิดข้อผิดพลาด')
    getStudentCourse()
    setIsFetchStudentCourseLoading(false)
  }

  useEffect(() => {
    getStudentCourse()
  }, [])

  useEffect(() => {
    if (isStudentCourseLoading) getStudentCourse()
  }, [isStudentCourseLoading])

  useEffect(() => {
    let sortText = ''

    if (sortProfile) {
      for (const sort in sortProfile) {
        switch (sort) {
          case 'rankShot':
            if (sortProfile.rankShot == 1) {
              sortText += 'ลำดับชั้นยศ: มากไปน้อย //'
            } else {
              sortText += 'ลำดับชั้นยศ: น้อยไปมาก //'
            }
            break
          case 'age':
            if (sortProfile.age == 1) {
              sortText += 'อายุ: น้อยไปมาก //'
            } else {
              sortText += 'อายุ: มากไปน้อย //'
            }
            break
          case 'startDate':
            if (sortProfile.startDate == 1) {
              sortText += 'วันที่บรรจุ: ก่อนไปหลัง //'
            } else {
              sortText += 'วันที่บรรจุ: หลังไปก่อน //'
            }
            break
          case 'rank_year':
            if (sortProfile.rank_year == 1) {
              sortText += 'ระยะเวลาการครองยศ: น้อยไปมาก //'
            } else {
              sortText += 'ระยะเวลาการครองยศ: มากไปน้อย //'
            }
            break
          case 'bornEduCode': // TODO CHECK
            if (sortProfile.bornEduCode == 1) {
              sortText += 'คุณวุฒิที่ใช้บรรจุ: น้อยไปมาก //'
            } else {
              sortText += 'คุณวุฒิที่ใช้บรรจุ: มากไปน้อย //'
            }
            break
          case 'highDegreeCode': // TODO CHECK
            if (sortProfile.highDegreeCode == 1) {
              sortText += 'คุณวุฒิสูงสุด: มากไปน้อย //'
            } else {
              sortText += 'คุณวุฒิสูงสุด: น้อยไปมาก //'
            }
            break
          case 'unit_no': // TODO CHECK
            if (sortProfile.unit_no == 1) {
              sortText += 'นขต.: น้อยไปมาก //'
            } else {
              sortText += 'นขต.: มากไปน้อย //'
            }
            break
          case 'spcNo': // TODO CHECK
            if (sortProfile.spcNo == 1) {
              sortText += 'หน่วย หน.นขต.: น้อยไปมาก //'
            } else {
              sortText += 'หน่วย หน.นขต.: มากไปน้อย //'
            }
            break
          case 'positionAddDateUnit':
            if (sortProfile.positionAddDateUnit == 1) {
              sortText += 'สิทธิ์เข้าอัตรา(หน่วย): ก่อนไปหลัง //'
            } else {
              sortText += 'สิทธิ์เข้าอัตรา(หน่วย): หลังไปก่อน //'
            }
            break
          case 'positionAddDateUnitSpc':
            if (sortProfile.positionAddDateUnitSpc == 1) {
              sortText += 'สิทธิ์เข้าอัตรา(สาย): ก่อนไปหลัง //'
            } else {
              sortText += 'สิทธิ์เข้าอัตรา(สาย): หลังไปก่อน //'
            }
            break
        }
      }
      setSortProfileText(sortText.slice(0, -2))
    }
  }, [sortProfile])

  useEffect(() => {
    if (eclFile) {
      const studentCourseService = new StudentCourseService()
      studentCourseService
        .uploadEclScore(courseId, eclFile, token)
        .then((res) => {
          successNotify('นำเข้าสำเร็จ')
          getStudentCourse()
        })
        .catch((err) => {
          errorNotify(err.message)
        })
    }
  }, [eclFile])

  useEffect(() => {
    if (healthFile) {
      const studentCourseService = new StudentCourseService()
      studentCourseService
        .uploadHealthFile(courseId, healthFile, token)
        .then((res) => {
          successNotify('นำเข้าสำเร็จ')
          getStudentCourse()
        })
        .catch((err) => {
          errorNotify(err.message)
        })
    }
  }, [healthFile])

  useEffect(() => {
    if (allFile) {
      const studentCourseService = new StudentCourseService()
      studentCourseService
        .uploadAllImportFile(courseId, allFile, token)
        .then((res) => {
          successNotify('นำเข้าสำเร็จ')
          getStudentCourse()
        })
        .catch((err) => {
          errorNotify(err.message)
        })
    }
  }, [allFile])

  useEffect(() => {
    if (finalTermFile) {
      const studentCourseService = new StudentCourseService()
      studentCourseService
        .uploadFinalTermFile(courseId, finalTermFile, token)
        .then((res) => {
          successNotify('นำเข้าสำเร็จ')
          getStudentCourse()
        })
        .catch((err) => {
          errorNotify(err.message)
        })
    }
  }, [finalTermFile])

  useEffect(() => {
    setStudentCourseExport(
      handleSetStudentCourseExport(studentCourses[activeTerm]?.data || []),
    )
  }, [activeTerm])

  let headers = []

  const headerBase = [
    { label: '#', key: 'index' },
    { label: 'เลขยศ', key: 'rankShot' },
    { label: 'ยศ', key: 'rankAbbrName' },
    // { label: 'คำนำหน้าชื่อ', key: 'pme_data.PREFIX_ABBR_NAME' },
    { label: 'เพศ', key: 'gender' },
    { label: 'ชื่อ-นามสกุล', key: 'fullName' },
    { label: 'อาวุโสชั้นยศ', key: 'totSeq' },
    { label: 'ตำแหน่ง', key: 'pme_data.POS_ORG_ABBR_NAME' },
    { label: 'ลชทอ.หลัก', key: 'pme_data.SKILL_NO_01' },
    { label: 'ลชทอ.รอง1', key: 'pme_data.SKILL_NO_02' },
    { label: 'ลชทอ.รอง2', key: 'pme_data.SKILL_NO_03' },
    { label: 'วัน เดือน ปี เกิด', key: 'birthDateTh' },
    // { label: 'ปรับลดปีครองยศ', key: 'rankAbbrName' },
    { label: 'ภูมิลำเนาปัจจุบัน', key: 'pme_data.ADDRESS1' },
    { label: 'หมายเลขบัตรประจำตัวประชาชน', key: 'citizenIdText' },
    { label: 'airforceIdText', key: 'airforceIdText' },
    { label: 'ชื่อ - สกุล บิดา', key: 'pme_data.NAME_FATHER' },
    { label: 'ชื่อ - สกุล มารดา', key: 'pme_data.NAME_MOTHER' },
    { label: 'นขต.ทอ.', key: 'pme_data.ORG_ABBR_NAME' },
    { label: 'เลขหน่วย', key: 'unit_no' },
    { label: 'หน่วย หน.สายวิทยาการ', key: 'unitSpcName' },
    { label: 'เลข หน.สายวิทยาการ', key: 'spcNoOrg' },
    { label: 'สายวิทยาการ', key: 'spcName' },
    { label: 'เลขสายวิทยาการ', key: 'spcNo' },
    { label: 'วันที่บรรจุ', key: 'startDateTh' },
    { label: 'วันยศปัจจุบัน', key: 'rankDateTh' },
    { label: 'อายุ', key: 'age' },
    { label: 'ระยะเวลาการครองยศ', key: 'seniorOfRank' },
    { label: 'ระยะเวลาการครองยศ(Text)', key: 'seniorOfRankText' },
    { label: 'คุณวุฒิที่ใช้บรรจุ', key: 'bornEduName' },
    { label: 'คุณวุฒิสูงสุด', key: 'degreeAbbrName' },
    { label: 'คะแนนภาษาอังกฤษ', key: 'ecl_score' },
    { label: 'คะแนนภาษาอังกฤษ นขต.', key: 'ecl_unit_score' },
    { label: 'วันที่คะแนนภาษาอังกฤษ นขต.', key: 'ecl_unit_date_th' },
    { label: 'ผลการตรวจร่างกาย', key: 'health_text' },
    { label: 'สถานที่ตรวจสุขภาพ', key: 'healthCheckLocateText' },
    { label: 'คะแนนประเมิน รอบ เม.ย.', key: 'pme_data.SCORE_CURRENT_APR' },
    { label: 'คะแนนประเมิน รอบ ต.ค.', key: 'pme_data.SCORE_CURRENT_OCT' },
    { label: 'รุ่น นนอ.', key: 'pme_data.AIRCADET_CLASS' },
    { label: 'ปีจบ นนอ.', key: 'pme_data.YEAR_SUCCESS_AIRCADET' },
    { label: 'คะแนน นนอ.', key: 'pme_data.AIRCADET' },
    { label: 'รุ่น นม.', key: 'pme_data.GEN_NO_OTS' },
    { label: 'ปีจบ นม.', key: 'pme_data.YEAR_SUCCESS_OTS' },
    { label: 'คะแนน นม.', key: 'pme_data.OTS' },
    { label: 'รุ่น นฝ.', key: 'pme_data.GEN_NO_SOS' },
    { label: 'ปีจบ นฝ.', key: 'pme_data.YEAR_SUCCESS_SOS' },
    { label: 'คะแนน นฝ.', key: 'pme_data.SOS' },
    { label: 'รุ่น เสธ,นอส.', key: 'pme_data.GEN_NO_ACSC' },
    { label: 'ปีจบ เสธ,นอส.', key: 'pme_data.YEAR_SUCCESS_ACSC' },
    { label: 'คะแนน เสธ,นอส.', key: 'pme_data.ACSC' },
    { label: 'ประวัติการศึกษารวม', key: 'pme_data.EDU' },
    { label: 'กำเนิด', key: 'pme_data.BORN_NAME' },
  ]

  const headerUnit = [
    ...headerBase,
    { label: 'แผนสิทธิ์เข้าอัตราหน่วย', key: 'levelUpPlanUnitText' },
    { label: 'สิทธิ์เข้าอัตราหน่วย', key: 'positionAddDateUnit' },
    { label: 'ตำแหน่งที่จะย้ายเข้าหน่วย', key: 'positionAddUnit' },
    { label: 'ลำดับหน่วย', key: 'unit_order' },
    { label: 'รุ่นหน่วย', key: 'unit_term_text' },
    { label: 'รุ่นสำรองหน่วย', key: 'unit_reserve_term_text' },
    { label: 'ผ่านคุณสมบัติ', key: 'unit_is_pass_qualification_text' },
    { label: 'หมายเหตุ', key: 'unit_note' },
  ]

  const headerSpc = [
    ...headerBase,
    { label: 'แผนสิทธิ์เข้าอัตราหน่วย', key: 'levelUpPlanUnitText' },
    { label: 'แผนสิทธิ์เข้าอัตราสาย', key: 'levelUpPlanUnitSpcText' },
    { label: 'สิทธิ์เข้าอัตราหน่วย', key: 'positionAddDateUnitTh' },
    { label: 'สิทธิ์เข้าอัตราสาย', key: 'positionAddDateUnitSpcTh' },
    { label: 'ตำแหน่งที่จะย้ายเข้าหน่วย', key: 'positionAddUnit' },
    { label: 'ตำแหน่งที่จะย้ายเข้าสาย', key: 'positionAddUnitSpc' },
    { label: 'ลำดับหน่วย', key: 'unit_order' },
    { label: 'ลำดับสาย', key: 'spc_order' },
    { label: 'รุ่นหน่วย', key: 'unit_term_text' },
    { label: 'รุ่นสำรองหน่วย', key: 'unit_reserve_term_text' },
    { label: 'รุ่นสาย', key: 'line_term_text' },
    { label: 'รุ่นสำรองสาย', key: 'line_reserve_term_text' },
    { label: 'ผ่านคุณสมบัติ', key: 'spc_is_pass_qualification_text' },
    { label: 'หมายเหตุ(หน่วย)', key: 'unit_note' },
    { label: 'หมายเหตุ', key: 'spc_note' },
  ]

  const headerAdmin = [
    ...headerBase,
    { label: 'สิทธิ์เข้าอัตราหน่วย', key: 'positionAddDateUnitTh' },
    { label: 'สิทธิ์เข้าอัตราสาย', key: 'positionAddDateUnitSpcTh' },
    { label: 'ตำแหน่งที่จะย้ายเข้าหน่วย', key: 'positionAddUnit' },
    { label: 'ตำแหน่งที่จะย้ายเข้าสาย', key: 'positionAddUnitSpc' },
    { label: 'ลำดับหน่วย', key: 'unit_order' },
    { label: 'ลำดับสาย', key: 'spc_order' },
    { label: 'ลำดับ กพ.', key: 'order' },
    { label: 'รุ่นหน่วย', key: 'unit_term_text' },
    { label: 'รุ่นสำรองหน่วย', key: 'unit_reserve_term_text' },
    { label: 'รุ่นสาย', key: 'line_term_text' },
    { label: 'รุ่นสำรองสาย', key: 'line_reserve_term_text' },
    { label: 'สรุปรุ่น', key: 'term_text' },
    { label: 'รุ่นสำรอง', key: 'reserve_term_text' },
    { label: 'ผ่านคุณสมบัติ', key: 'is_pass_qualification_text' },
    { label: 'หมายเหตุ(หน่วย)', key: 'unit_note' },
    { label: 'หมายเหตุ(สาย)', key: 'spc_note' },
    { label: 'หมายเหตุ', key: 'note' },
  ]

  switch (role) {
    case 'admin':
      headers = headerAdmin
      break
    case 'adminUnitSpc':
      headers = headerSpc
      break
    case 'adminUnit':
      headers = headerUnit
      break
  }

  const requestEclheaders = [
    { label: 'AirforceID', key: 'airforceIdText' },
    { label: 'ชื่อ-นามสกุล', key: 'fullName' },
    { label: 'สังกัด', key: 'pme_data.ORG_ABBR_NAME' },
    { label: 'คะแนนECL', key: '' },
    { label: 'ผลตรวจสุขภาพ', key: '' },
    { label: 'รุ่นที่จัด', key: '' },
  ]

  const handlePassQualificationClick = () => {
    getStudentCourseOnlyPassQualified()
  }
  return (
    <>
      <ApproveStudentCourseModal
        showApproveStudentCourseModal={showApproveStudentCourseModal}
        setShowApprovStudentCourseModal={setShowApprovStudentCourseModal}
        courseId={courseId}
        getStudentCourse={getStudentCourse}
      />
      <ClearStudentCourseModal
        showClearStudentCourseModal={showClearStudentCourseModal}
        setShowClearStudentCourseModal={setShowClearStudentCourseModal}
        courseId={courseId}
        getStudentCourse={getStudentCourse}
      />
      {showAddStudentModal && (
        <SearchStudentModal
          getStudentCourse={getStudentCourse}
          showAddStudentModal={showAddStudentModal}
          setShowAddStudentModal={setShowAddStudentModal}
          errorNotify={errorNotify}
          successNotify={successNotify}
          courseId={courseId}
          majorCourseName={major_name}
        />
      )}
      {showStudentChangeTermModal && (
        <StudentChangeTermModal
          courseUpdateAvailable={courseUpdateAvailable}
          getStudentCourse={getStudentCourse}
          showStudentChangeTermModal={showStudentChangeTermModal}
          setShowStudentChangeTermModal={setShowStudentChangeTermModal}
          studentChangeData={studentChangeData}
          role={role}
          terms={terms}
          token={token}
          sortProfile={sortProfile}
          isStudentCourseApprove={isStudentCourseApprove}
          courseInfo={courseInfo}
          majorCourse={majorCourse}
        />
      )}
      {showStudentCourseSortModal && (
        <StudentCourseSortModal
          getStudentCourse={getStudentCourse}
          showStudentCourseSortModal={showStudentCourseSortModal}
          setShowStudentCourseSortModal={setShowStudentCourseSortModal}
          errorNotify={errorNotify}
          successNotify={successNotify}
          setStudentCourses={setStudentCourses}
          studentCourses={studentCourses}
        />
      )}
      {courseUpdateAvailable && (
        <div className='manage-container'>
          <Row className='fetch-students-at-container'>
            <Col md={12} className='label-fetch-students-at'>
              ดึงข้อมูล HRIS ล่าสุด:{' '}
              {fetchStudentsAt
                ? new Date(fetchStudentsAt).toLocaleString('th-TH')
                : new Date(fetchStudentCourseAt).toLocaleString('en-NZ')}
            </Col>
          </Row>
          <Row className='setting-container'>
            <Col md={6} className='btn-left-container'>
              <Row>
                <Col className='sort-btn-container' md={12}>
                  <Button
                    className={`sort-student ${
                      isStudentCourseApprove ? 'disabled' : ''
                    }`}
                    variant='outline-primary'
                    onClick={setShowStudentCourseSortModal}>
                    จัดเรียงลำดับ
                  </Button>
                  <Button
                    className={`${isStudentCourseApprove ? 'disabled' : ''}`}
                    variant='outline-danger'
                    onClick={clearStudentCourseSort}>
                    ล้างการจัดเรียง
                  </Button>
                  {role === 'admin' && (
                    <ButtonGroup className='tool-admin-btn'>
                      <DropdownButton
                        as={ButtonGroup}
                        title='Tool Admin'
                        variant='outline-dark'
                        id='bg-nested-dropdown'>
                        <Dropdown.Item
                          onClick={() => handleOnArrangeTerm('unit')}>
                          จัดเรียงรุ่นตามหน่วย
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleOnArrangeTerm('spc')}>
                          จัดเรียงรุ่นตามสายวิทยาการ
                        </Dropdown.Item>
                      </DropdownButton>
                    </ButtonGroup>
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={6} className='btn-right-container'>
              <Row>
                <Col md={12}>
                  {role === 'admin' && (
                    <ButtonGroup className='fetch-data-btn'>
                      <DropdownButton
                        as={ButtonGroup}
                        variant='outline-primary'
                        title={
                          <>
                            {isFetchStudentCourseLoading && (
                              <i
                                className='fa fa-spinner fa-spin'
                                aria-hidden='true'></i>
                            )}
                            ดึงข้อมูล
                          </>
                        }
                        id='bg-nested-dropdown'>
                        <Dropdown.Item
                          disabled={fetchStudentCourseDisabled}
                          onClick={() => fetchStudentCourse()}>
                          ดึงข้อมูลจาก HRIS
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnGetEclInHRIS}>
                          ดึงผลทดสอบภาษาอังกฤษ
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnGetHealthInHRIS}>
                          ดึงผลตรวจสุขภาพ
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setShowClearStudentCourseModal(true)
                          }}>
                          ล้างข้อมูลทั้งหมด
                        </Dropdown.Item>
                      </DropdownButton>
                    </ButtonGroup>
                  )}
                  {role === 'admin' && (
                    <ButtonGroup className='import-data-btn'>
                      <DropdownButton
                        as={ButtonGroup}
                        title='เพิ่มข้อมูล'
                        variant='outline-success'
                        id='bg-nested-dropdown'>
                        <Dropdown.Item
                          onClick={() => handleAddStudentModalShow()}>
                          เพิ่มชื่อผู้เรียน
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnImportEcl}>
                          Import File ผลทดสอบภาษาอังกฤษ
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnImportHealth}>
                          Import File ผลตรวจสุขภาพ
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnImportFinalTerm}>
                          Import File ผลการจัดรุ่น
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnImportAllFile}>
                          Import File ผลทั้งหมด
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleOnExportEcl}>
                          แบบฟอร์มสำหรับ Import ข้อมูล
                        </Dropdown.Item>
                      </DropdownButton>
                    </ButtonGroup>
                  )}
                  <ButtonGroup className='export-data-btn'>
                    <DropdownButton
                      as={ButtonGroup}
                      title='Export'
                      variant='outline-secondary'
                      id='bg-nested-dropdown'>
                      <Dropdown.Item
                        href={`/majorcourses/${major_name}/course/${course_name}/print`}
                        target='_blank'>
                        พิมพ์ผลการจัดเรียง
                      </Dropdown.Item>
                      {role === 'admin' && (
                        <Dropdown.Item
                          onClick={() => {
                            window.location.href = `/majorcourses/${major_name}/course/${course_name}/requestOrder`
                          }}>
                          รายชื่อออกคำสั่ง
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item onClick={handleOnExcelFileClick}>
                        EXCEL File
                      </Dropdown.Item>
                    </DropdownButton>
                  </ButtonGroup>

                  <input
                    type='file'
                    id='eclFile'
                    onChange={(e) => setEclFile(e.target.files[0])}
                    hidden
                  />
                  <input
                    type='file'
                    id='healthFile'
                    onChange={(e) => setHealthFile(e.target.files[0])}
                    hidden
                  />
                  <input
                    type='file'
                    id='finalTermFile'
                    onChange={(e) => setFinalTermFile(e.target.files[0])}
                    hidden
                  />
                  <input
                    type='file'
                    id='allFile'
                    onChange={(e) => setAllFile(e.target.files[0])}
                    hidden
                  />
                  <CSVLink
                    id='requestEclFile'
                    data={studentCourseExport}
                    headers={requestEclheaders}
                    filename={'Form Import คะแนน ผลสุขภาพ สรุปรุ่น'}
                  />
                </Col>
              </Row>
            </Col>
            <p className='sort-text'>
              จัดเรียงลำดับโดย =&gt; {sortProfileText}
            </p>

            {isUserUnitAdminOrUnitSpcAdmin && isStudentCourseApprove && (
              <div className='label-studentcourse-approve-at'>
                ส่งผลเมื่อ:{' '}
                {studentCourseApproveAt
                  ? new Date(studentCourseApproveAt).toLocaleString('th-TH')
                  : new Date(studentCourseApproveAt).toLocaleString('en-NZ')}
              </div>
            )}

            <CSVLink
              data={studentCourseExport}
              headers={headers}
              className='excelFile'
              filename={'ผลการจัดเรียง'}></CSVLink>
          </Row>
        </div>
      )}
      <StudentCourseTable
        studentCourses={studentCourses}
        handleStudentChangeTermModalShow={handleStudentChangeTermModalShow}
        role={role}
        terms={terms}
        isSpcApprove={isSpcApprove}
        setActiveTerm={setActiveTerm}
        isStudentCourseLoading={isStudentCourseLoading}
        isStudentAll={isStudentAll}
        handlePassQualificationClick={handlePassQualificationClick}
        activeTerm={activeTerm}
      />
      {isUserUnitAdminOrUnitSpcAdmin && isStudentCourseApprove && (
        <div className='info-footer'>
          <div className='label-sign'>
            <center>
              <span>______________________</span>
              <br />
              <div className='label-sign-name'>
                (___________________________)
              </div>
              <span className='label-sign-date'>
                {new Date().toLocaleString('th-TH').split(' ')[0]}
              </span>
            </center>
          </div>
          <div className='label-studentcourse-approve-at'>
            ส่งผลเมื่อ:{' '}
            {studentCourseApproveAt
              ? new Date(studentCourseApproveAt).toLocaleString('th-TH')
              : new Date(studentCourseApproveAt).toLocaleString('en-NZ')}
          </div>
        </div>
      )}
    </>
  )
}
